import React from "react";
import QuestionComponent from "./QuestionTypes/QuestionComponent";

const SupplementSectionRenderer = ({ questions = [], answers = {}, onChange }) => {
  // Agrupar por sym_group
  const grouped = questions.reduce((acc, q) => {
    const group = q.sym_group || 0;
    if (!acc[group]) acc[group] = [];
    acc[group].push(q);
    return acc;
  }, {});

  return (
    <div className="supplement-section">
      {Object.entries(grouped).map(([groupId, groupQuestions]) => (
        <div key={groupId} className="supplement-group mb-5">
          {groupQuestions.map((question) => {


            if (question.type === "categoryTitle") {
              return (
                <div key={question.sym_id} className="category-title-block mb-3">
                  <h4 className="opensans"><strong>{question.label}</strong></h4>
                  {question.sublabel && <small className="text-muted">{question.sublabel}</small>}
                </div>
              );
            }
            
            return (
              <QuestionComponent
                key={question.sym_id}
                questions={[question]}
                answers={answers}
                onChange={onChange}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default SupplementSectionRenderer;
